import type {Model} from './architecture.js';
import type {
  ActionButtonOption,
  OpenEditExportModalEventDetail,
} from './types.js';
import {OPEN_EDIT_EXPORT_MODAL_EVENT} from '#lit/components/audiences/audience_export_edit/architecture.js';

export const createOpenManageModalEvent = (
  model: Model,
  option: ActionButtonOption
) => {
  return new CustomEvent<OpenEditExportModalEventDetail>(
    OPEN_EDIT_EXPORT_MODAL_EVENT,
    {
      detail: {
        audienceExport: model.audienceExport,
        destinationName: model.destinationName,
        destinationIcon: model.destinationIcon,
        frequencies: model.frequencies,
        label: option.label,
        isExpired: model.isExpired,
      },
    }
  );
};

export const isVisible = (model: Model, option: ActionButtonOption) => {
  return option.getVisibility?.(model).visible;
};

export const isDisabled = (model: Model, option: ActionButtonOption) => {
  return option.getVisibility?.(model).disabled;
};
